import {CONSTANTS} from "../../constants/constants"
import type {EditorMode} from "../../types/types"
import {Button} from "../Button/Button"
import styles from "./ModeSwitcher.module.css"

interface ModeSwitcherProps {
    onModeChange: (mode: EditorMode) => void
    disabled: boolean
}

export const ModeSwitcher = ({onModeChange, disabled}: ModeSwitcherProps) => {
    return (
        <div className={styles.modeButtons}>
            <Button
                onClick={() => onModeChange(CONSTANTS.EDITOR_MODES.CROP)}
                className={styles.button}
                disabled={disabled}
            >
                Crop
            </Button>
            <Button
                onClick={() => onModeChange(CONSTANTS.EDITOR_MODES.TILE)}
                className={styles.button}
                disabled={disabled}
            >
                Tille
            </Button>
        </div>
    )
}
